import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  TextBlock,
  ImageBlock,
  BigImageBlock,
  ImageCaption,
  ImageTextShadow,
  ImageTextPrint,
  OverlayTextBlock,
} from '../styles/LongreadBlockRenderer.styles';
import {
  ColoredBlock,
  NormalBlock,
  ImageBlockComponent,
  SliderBlock,
  ProjectsBlock,
  ProductsBlock,
  PodcastBlock,
  TwoPicturesBlock,
  VideoBlock,
  CardBlock,
  LinkBlock,
} from './blocks';
import { invertColor } from '../utils/colorUtils';
import { LongreadBlockRendererProps } from '../types';

export const LongreadBlockRenderer: FC<LongreadBlockRendererProps> = ({ block, theme, backgroundColor, isActive, forceWhiteBackground = false, contentPadding, contentPaddingMobile, stackOnMobile = false }) => {
  if (!block) return null;

  const blockStyle = block.style;
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];


  const defaultTextColor = useMemo(() => {
    if (forceWhiteBackground) return '#151514';
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor, forceWhiteBackground]);

  // Рендеринг в зависимости от типа блока
  switch (blockStyle) {
    case 'colored':
    case 'annotation':
    case 'quote':
    case 'medium':
      return (
        <ColoredBlock
          block={block}
          backgroundColor={backgroundColor}
          padding={contentPadding}
          paddingMobile={contentPaddingMobile}
        />
      );

    case 'normal':
    case 'normal_emblem':
      return (
        <NormalBlock
          block={block}
          backgroundColor={backgroundColor}
          forceWhiteBackground={forceWhiteBackground}
          padding={contentPadding}
          paddingMobile={contentPaddingMobile}
          stackOnMobile={stackOnMobile}
        />
      );

    case 'normal_image':
    case 'normal_card':
      if (hasAttachments) {
        return (
          <LongreadBlockWrapper>
            <ImageBlock>
              <ResizedImageEnhanced files={files} />
              {block.caption && (
                <ImageCaption textColor={defaultTextColor}>
                  <FormatLinkedText text={block.caption} />
                </ImageCaption>
              )}
              {block.text && (
                <OverlayTextBlock textColor={defaultTextColor} hasCaption={!!block.caption}>
                  <FormatLinkedText text={block.text} />
                </OverlayTextBlock>
              )}
            </ImageBlock>
          </LongreadBlockWrapper>
        );
      }
      return (
        <LongreadBlockWrapper>
          <TextBlock textColor={defaultTextColor}>
            {block.text && <FormatLinkedText text={block.text} />}
          </TextBlock>
        </LongreadBlockWrapper>
      );

    case 'big':
      const textPosition = block.titlePosition || block.textPosition || 'bottom';
      return (
        <LongreadBlockWrapper>
          <BigImageBlock data-fullscreen-image $mobilePadding={contentPaddingMobile}>
            {hasAttachments && <ResizedImageEnhanced files={files} />}
            {block.text && (
              <>
                <ImageTextShadow position={textPosition} />
                <ImageTextPrint position={textPosition}>
                  <FormatLinkedText text={block.text} />
                </ImageTextPrint>
              </>
            )}
            {block.caption && (
              <ImageCaption textColor={defaultTextColor}>
                <FormatLinkedText text={block.caption} />
              </ImageCaption>
            )}
          </BigImageBlock>
        </LongreadBlockWrapper>
      );

    case 'image':
    case 'as_cover':
      return <ImageBlockComponent block={block} backgroundColor={backgroundColor} />;

    case 'slider':
      return <SliderBlock block={block} backgroundColor={backgroundColor} />;

    case 'bibliography':
    case 'image_sources':
      return (
        <LongreadBlockWrapper style={{ backgroundColor: '#FEFEFE' }}>
          <TextBlock textColor={defaultTextColor}>
            {block.text && <FormatLinkedText text={block.text} />}
          </TextBlock>
        </LongreadBlockWrapper>
      );

    case 'two_pictures':
      return <TwoPicturesBlock block={block} backgroundColor={backgroundColor} stackOnMobile={stackOnMobile} />;

    case 'projects':
      return <ProjectsBlock block={block} backgroundColor={backgroundColor} />;

    case 'products':
      return <ProductsBlock block={block} backgroundColor={backgroundColor} />;

    case 'podcast':
      return <PodcastBlock block={block} backgroundColor={backgroundColor} />;

    case 'video':
      return <VideoBlock block={block} backgroundColor={backgroundColor} isActive={isActive} />;

    case 'card':
      return <CardBlock block={block} backgroundColor={backgroundColor} />;

    case 'link':
      return <LinkBlock block={block} backgroundColor={backgroundColor} />;

    default:
      return (
        <LongreadBlockWrapper>
          {block.text && (
            <TextBlock textColor={defaultTextColor}>
              <FormatLinkedText text={block.text} />
            </TextBlock>
          )}
          {hasAttachments && (
            <ImageBlock>
              <ResizedImageEnhanced files={files} />
              {block.caption && (
                <ImageCaption textColor={defaultTextColor}>
                  <FormatLinkedText text={block.caption} />
                </ImageCaption>
              )}
            </ImageBlock>
          )}
        </LongreadBlockWrapper>
      );
  }
};
import { FC, useMemo } from 'react';
import { FormatLinkedText } from 'brg-longread';
import ResizedImageEnhanced from '../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  TextBlock,
  ImageBlock,
  BigImageBlock,
  ImageCaption,
  ImageTextShadow,
  ImageTextPrint,
  OverlayTextBlock,
} from '../styles/LongreadBlockRenderer.styles';
import {
  ColoredBlock,
  NormalBlock,
  ImageBlockComponent,
  SliderBlock,
  ProjectsBlock,
  ProductsBlock,
  PodcastBlock,
  TwoPicturesBlock,
  VideoBlock,
  CardBlock,
  LinkBlock,
} from './blocks';
import { invertColor } from '../utils/colorUtils';
import { LongreadBlockRendererProps } from '../types';

export const LongreadBlockRenderer: FC<LongreadBlockRendererProps> = ({ block, theme, backgroundColor, isActive, forceWhiteBackground = false, contentPadding, contentPaddingMobile, stackOnMobile = false }) => {
  if (!block) return null;

  const blockStyle = block.style;
  const hasAttachments = block.attachments && block.attachments.length > 0;
  const firstAttachment = hasAttachments ? block.attachments[0] : null;
  const files = firstAttachment?.files || [];


  const defaultTextColor = useMemo(() => {
    if (forceWhiteBackground) return '#151514';
    if (!backgroundColor) return '#151514';
    return invertColor(backgroundColor, '#FEFEFE', '#151514');
  }, [backgroundColor, forceWhiteBackground]);

  // Рендеринг в зависимости от типа блока
  switch (blockStyle) {
    case 'colored':
    case 'annotation':
    case 'quote':
    case 'medium':
      return (
        <ColoredBlock
          block={block}
          backgroundColor={backgroundColor}
          padding={contentPadding}
          paddingMobile={contentPaddingMobile}
        />
      );

    case 'normal':
    case 'normal_emblem':
      return (
        <NormalBlock
          block={block}
          backgroundColor={backgroundColor}
          forceWhiteBackground={forceWhiteBackground}
          padding={contentPadding}
          paddingMobile={contentPaddingMobile}
          stackOnMobile={stackOnMobile}
        />
      );

    case 'normal_image':
    case 'normal_card':
      if (hasAttachments) {
        return (
          <LongreadBlockWrapper>
            <ImageBlock>
              <ResizedImageEnhanced files={files} />
              {block.caption && (
                <ImageCaption textColor={defaultTextColor}>
                  <FormatLinkedText text={block.caption} />
                </ImageCaption>
              )}
              {block.text && (
                <OverlayTextBlock textColor={defaultTextColor} hasCaption={!!block.caption}>
                  <FormatLinkedText text={block.text} />
                </OverlayTextBlock>
              )}
            </ImageBlock>
          </LongreadBlockWrapper>
        );
      }
      return (
        <LongreadBlockWrapper>
          <TextBlock textColor={defaultTextColor}>
            {block.text && <FormatLinkedText text={block.text} />}
          </TextBlock>
        </LongreadBlockWrapper>
      );

    case 'big':
      const textPosition = block.titlePosition || block.textPosition || 'bottom';
      return (
        <LongreadBlockWrapper>
          <BigImageBlock data-fullscreen-image $mobilePadding={contentPaddingMobile}>
            {hasAttachments && <ResizedImageEnhanced files={files} />}
            {block.text && (
              <>
                <ImageTextShadow position={textPosition} />
                <ImageTextPrint position={textPosition}>
                  <FormatLinkedText text={block.text} />
                </ImageTextPrint>
              </>
            )}
            {block.caption && (
              <ImageCaption textColor={defaultTextColor}>
                <FormatLinkedText text={block.caption} />
              </ImageCaption>
            )}
          </BigImageBlock>
        </LongreadBlockWrapper>
      );

    case 'image':
    case 'as_cover':
      return <ImageBlockComponent block={block} backgroundColor={backgroundColor} />;

    case 'slider':
      return <SliderBlock block={block} backgroundColor={backgroundColor} />;

    case 'bibliography':
    case 'image_sources':
      return (
        <LongreadBlockWrapper style={{ backgroundColor: '#FEFEFE' }}>
          <TextBlock textColor={defaultTextColor}>
            {block.text && <FormatLinkedText text={block.text} />}
          </TextBlock>
        </LongreadBlockWrapper>
      );

    case 'two_pictures':
      return <TwoPicturesBlock block={block} backgroundColor={backgroundColor} stackOnMobile={stackOnMobile} />;

    case 'projects':
      return <ProjectsBlock block={block} backgroundColor={backgroundColor} />;

    case 'products':
      return <ProductsBlock block={block} backgroundColor={backgroundColor} />;

    case 'podcast':
      return <PodcastBlock block={block} backgroundColor={backgroundColor} />;

    case 'video':
      return <VideoBlock block={block} backgroundColor={backgroundColor} isActive={isActive} />;

    case 'card':
      return <CardBlock block={block} backgroundColor={backgroundColor} />;

    case 'link':
      return <LinkBlock block={block} backgroundColor={backgroundColor} />;

    default:
      return (
        <LongreadBlockWrapper>
          {block.text && (
            <TextBlock textColor={defaultTextColor}>
              <FormatLinkedText text={block.text} />
            </TextBlock>
          )}
          {hasAttachments && (
            <ImageBlock>
              <ResizedImageEnhanced files={files} />
              {block.caption && (
                <ImageCaption textColor={defaultTextColor}>
                  <FormatLinkedText text={block.caption} />
                </ImageCaption>
              )}
            </ImageBlock>
          )}
        </LongreadBlockWrapper>
      );
  }
};
